<template>
    <div class="region_list">
        <div class="btn-group choice_region">
            <button type="button" v-for="item in regions" class="btn btn-outline-primary waves-effect waves-themed" :class="calss_region(item)"  @click.prevent="set_active(item)" >
                {{item.name}}
            </button>
        </div>

        <div class="panel-tag mt-2 mb-2">
            <div id="js_change_tab_direction" class="btn-group btn-group-sm btn-group-toggle" data-toggle="buttons">

                <label class="btn btn-primary active waves-effect waves-themed cursor-pointer" v-on:click="check_uncheck(true)" data-action="" data-class="n" data-target="">
                    <input type="radio" name="radioNameTabDirection" checked="" value="nav nav-tabs"> Обрати Всі
                </label>

                <label class="btn btn-success waves-effect waves-themed cursor-pointer"  v-on:click="check_uncheck(false)" data-action="" data-class="" data-target="">
                    <input type="radio" name="radioNameTabDirection" value="nav nav-tabs justify-content-end"> Зняти виділення
                </label>
            </div>
            <div class="badge badge-primary float-right">В списку {{ userlist.length  }} користувачів </div>
        </div>

        <div class="load_user pt-3" v-if="is_load">
            <div class="text-center">
                <BSpinner variant="warning"></BSpinner>
            </div>
        </div>

        <user_list v-bind:users="users"></user_list>

        <!--
        <div class="right_side">
            <div class="intro_text">
                <div class="mt-3">
                    <b-button-group>
                        <b-button @click.prevent="check_all" variant="info">{{check_text}}</b-button>
                    </b-button-group>
                </div>
            </div>
        </div>

        <div class="clr"></div>
        -->
    </div>
</template>

<script>
import {BForm, BFormGroup, BFormInput,BInputGroupText,BSpinner} from 'bootstrap-vue-next';

    import {createHelpers} from 'vuex-map-fields';
    const {mapFields} = createHelpers({
        getterType: 'users_filter/getUfilterField',
        mutationType: 'users_filter/updateUfilterField',
    });
    
    
    import user_list from './users_list.vue'
    import {mapGetters} from "vuex";
    
    
    export default {
        components : {
          user_list,
            BSpinner
        },

        name: "region",
        created() {
            if (this.regions.length == 0) {
                this.load_regions();
            }
            this.load_users();
        },
        data () {
          return {
              form : {
                  reg_id : 0,
                  cur_type : 'region'
              },
              is_load : false,
              is_check_active : false,
          }
        },
        
        methods: {
            check_uncheck(state) {
                EventBus.$emit('check_list',{active: state});
            },

            check_all() {
                if( this.is_check_active){
                    this.is_check_active = false;
                }
                else {
                    this.is_check_active = true;
                }
                EventBus.$emit('check_list',{active: this.is_check_active});
            },
            
            set_active (item) {
                this.$store.dispatch('users_filter/SET_ACTIVE_REG', item);
                this.is_check_active = false;
                this.load_users();
            },

            async load_regions ()  {
                let self = this;
                await api.get('/regions').then(({data}) => {
                    if (data.status == "operation_success") {
                       
                        let regions = data.data;
                        self.$store.dispatch('users_filter/SET_REG_LIST', regions);
                        
                        regions.map(function(region) {
                            if(self.cur_user_srv > 0 && self.cur_user_srv === parseInt(region.id)) {
                                self.$store.dispatch('users_filter/SET_ACTIVE_REG', region);
                                self.load_users();
                            }
                        });
                    }
                }).catch(err => {
                    console.log(err);
                });
            },

            async load_users ()  {
                this.is_load = true;
                this.$store.dispatch('users_filter/SET_USERS_LIST', []);

                if(this.active_region.id > 0) {
                    await api.post('/users',this.send_form).then(({data}) => {
                        if (data.status == "operation_success") {
                            this.$store.dispatch('users_filter/SET_USERS_LIST', data.data);
                        }
                        this.is_load = false;
                    }).catch(err => {
                        this.is_load = false;
                        console.log(err);
                    });
                }
            },
            
            calss_region(region) {
                if(parseInt(region.id) === parseInt(this.active_region.id)) {
                    return 'active';
                }
                return  '';
            }
        },
        
        computed: {
            
            ...mapGetters({
                'cur_user' : "user/getUser",
            }),
            
            ...mapFields([
                'regions',
                'active_region',
                'users',
            ]),
            
            check_text() {
                if(this.is_check_active) {
                    return 'Зняти виділення'
                }
                
                return 'Виділити всі';
            },
            
            send_form () {
                this.form.reg_id = this.active_region.id;
                return this.form;
            },
            
            userlist () {
                return  this.users;
            },
            
            cur_user_srv() {
                
                try {
                    return parseInt(this.cur_user.serv_id);
                }
                catch (e) {
                
                }
                return  0;
            }
            
        },



    }
</script>

<style scoped>
    .choice_region {
        max-width: 100%;
        overflow-y: auto;
        width: 100%;
    }


</style>
